const idGenerate = (() => {
    let id = 1;
    return () => {
        return id++;
    }
})();

export default idGenerate;